<template>
  <div id="mask">
    <div class="qrcode">
      <div style="background-color:white;border:2px solid #ddd;padding:10px;display:inline-block;margin-bottom:10px;">
        <qrcode-vue :value="src"  level="H"></qrcode-vue>
         <span>扫一扫,分享活动</span>
      </div>
    </div>

    <div class="banner_posi">
      <img :src="serve + '/bannerAD/bannerInfo/mask/mask2.png'" alt />
    </div>
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask7.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask8.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask9.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask10.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask11.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask12.jpg'" alt />
    <img :src="serve + '/bannerAD/bannerInfo/mask/mask13.jpg'" alt />
    <div class="foot">
      <div style="margin:0 auto;width:1200px;">
        <img :src="serve + '/bannerAD/bannerInfo/mask/mask1.jpg'" alt />
      </div>
      <div style="margin:0 auto;width:1200px;">
        <img :src="serve + '/bannerAD/bannerInfo/mask/mask3.jpg'" alt />
      </div>
      <div style="margin:0 auto;width:1200px;">
        <img :src="serve + '/bannerAD/bannerInfo/mask/mask4.jpg'" alt />
      </div>
    </div>
    <div class="foot1">
      <div style="margin:0 auto;width:1200px;">
        <img :src="serve + '/bannerAD/bannerInfo/mask/mask5.jpg'" alt />
      </div>
      <div style="margin:0 auto;width:1200px;">
        <img :src="serve + '/bannerAD/bannerInfo/mask/mask6.jpg'" alt />
      </div>
    </div>
    <div class="foot2">
      <div style="margin:0 auto;width:1200px;" class="clearfix">
        <div class="list" v-for="item in topic" :key="item.index">
          <router-link target="_blank" :to="'/product/'+item.id">
            <div class="list_img">
              <img :src="serve + '/' + item.images" alt />
            </div>
          </router-link>
          <router-link target="_blank" :to="'/product/'+item.id">
            <div class="list_title">{{item.title}}</div>
          </router-link>

          <div class="list_money">
            <div class="list_money1">
              <div>￥{{item.selling_price}}</div>
              <div>￥{{item.original_price}}</div>
            </div>
            <div class="list_car" @click="addcar(item.id)">
              <i
                class="fas fa-shopping-cart fa-lg"
                style="color:#fff;font-size:24px;margin-left: 4px;"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div @click="refresh1()" class="refresh" :class="{'ref_trans' : transfrom1}">
        <i class="fas fa-sync-alt" style="color:#F0250F;font-size:35px"></i>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
       serve: this.$store.state.serve,
      topic: [],
      topics: [],
      topics2: [],
      transfrom: true,
      transfrom1: false,
      src: 'https://www.bioflin.com/#/banner_mask'
    }
  },

  created() {
    this.geting()
  },
  watch: {},
  mounted() {},
  methods: {
    geting(e) {
      this.transfrom1 = true
      this.axios
        .get(this.serve + '/search', {
          params: {
            ThirdClass: 37,
            page: e
          }
        })
        .then(res => {
          this.topic = []
          this.transfrom1 = false
          var tab = res.data.results.concat()
          this.topic = tab
        })
    },
    refresh1() {
      if (this.transfrom == true) {
        this.geting(2)
        // this.topic = this.topics2;
        this.transfrom = false
      } else if (this.transfrom == false) {
        this.transfrom = true
        this.geting(1)
      }

      // if(this.transfrom == true){
      //   this.topic = this.topics
      //   this.transfrom = false
      // }else{
      //   this.geting()
      // }
      // var topics =  this.topic

      // if(this.transfrom == true){
      //   this.transfrom = false
      //   this.topic = this.topics
      // }else{
      //   console.log(1)
      //   this.topic = this.topics2
      // }
      // var topics1 = this.topic.splice(13,24)
    },
    addcar(id) {
      this.axios
        .get(this.serve + '/member/add_car', {
          params: {
            token: this.$cookies.get('token'),
            mobile: this.$cookies.get('user'),
            id: id,
            number: 1
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              type: 'success',
              message: '商品以加入购物车'
            })
          } else if (res.data.status == 'error') {
            this.$message({
              type: 'error',
              message: res.data.data
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#mask {
  position: relative;
  border-top: 2px solid #e2211c;
  .qrcode{
    position: absolute;
    top: 50px;
    right: 150px;
  }
  .banner_posi {
    width: 1308px;
    height: 1109px;
    position: absolute;
    margin-left: -654px;
    left: 50%;
    top: 378px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .refresh {
    width: 35px;
    height: 35px;
    margin: 0 auto;
    cursor: pointer;
    // text-align: center;
    margin-top: 30px;
  }
  @keyframes ref_trans {
    0% {
      transform: rotate(0);
    }
    50% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0);
    }
  }

  .ref_trans {
    transition: 0.5s;
    transform-origin: 50% 50%;
    animation: rotate 0.5s linear infinite; /*开始动画后无限循环，用来控制ref_trans*/
  }

  // .ref_trans {
  //   transform: rotate(360deg);
  //   transition: 1s;
  // }

  max-width: 100%;
  > img {
    width: 100%;
  }
  .foot {
    width: 100%;
    background: #fff;
  }
  .foot1 {
    width: 100%;
    background: #dee3dd;
  }

  .foot2 {
    width: 100%;
    background: #b7edff;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .list {
    float: left;
    width: 292px;
    height: 410px;
    background: #fff;
    margin-right: 8px;
    margin-bottom: 8px;

    .list_img {
      width: 270px;
      height: 270px;
      margin: 0 auto;
      padding-top: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .list_title {
      padding-top: 10px;
      width: 249px;
      height: 50px;
      overflow: hidden;
      margin: 0 auto;
      font-size: 17px;
      font-family: 'Microsoft YaHei';
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      line-height: 26px;
    }
    .list_title:hover {
      color: #e2211c;
    }
    .list_money {
      display: flex;
      justify-content: space-between;
      width: 249px;
      margin: 16px auto;
      .list_money1 {
        display: flex;
        align-items: center;
        :nth-child(1) {
          font-size: 22px;
          font-weight: 400;
          color: rgba(246, 78, 98, 1);
        }
        :nth-child(2) {
          margin-left: 10px;
          font-size: 17px;
          font-weight: 400;
          text-decoration: line-through;
          color: rgba(153, 153, 153, 1);
        }
      }
      .list_car {
        display: flex;
        // justify-content: center;
        cursor: pointer;

        align-items: center;
        width: 37px;
        height: 37px;
        background: #f0250f;
        border-radius: 6px;
      }
    }
  }
}
</style>
